import { List, ListItem } from '@mui/material';
import SelectableCard from '@/components/SelectableCard/SelectableCard';
import Heading from '../Heading/Heading';
import useStyles from './EcommOptionsList.styles';

interface SelectableCardItem {
  id: string;
  label: string;
  disabled?: boolean;
}

interface SelectableCardListProps {
  label: string;
  heading?: string;
  name: string;
  items: SelectableCardItem[] | undefined;
  selectedId: string | undefined;
  onSelect: (id: string) => void;
  onHover?: (id: string, isEntering: boolean) => void;
  isOnDark?: boolean;
  optionsContainerClassName?: string;
  cardContentClassName?: string;
  className?: string;
  increaseCardPadding?: boolean;
  'data-testid'?: string;
}

const EcommOptionsList: React.FC<SelectableCardListProps> = ({
  label,
  heading,
  name,
  items,
  selectedId,
  onSelect,
  onHover,
  isOnDark = false,
  cardContentClassName,
  optionsContainerClassName,
  className,
  increaseCardPadding = false,
  'data-testid': dataTestId,
}) => {
  const { classes, cx } = useStyles();

  return (
    <div
      role='radiogroup'
      aria-label={label}
      data-testid={dataTestId}
      className={className}
    >
      {heading && <Heading level='h4'>{heading}</Heading>}
      <List className={cx(classes.optionsContainer, optionsContainerClassName)}>
        {items?.map(({ id, label, disabled }) => (
          <ListItem
            key={id}
            onMouseEnter={() => onHover?.(id, true)}
            onMouseLeave={() => onHover?.(id, false)}
          >
            <SelectableCard
              name={name}
              value={id}
              isSelected={selectedId === id}
              onSelect={() => onSelect(id)}
              ariaLabel={label}
              increasePadding={increaseCardPadding}
              disabled={disabled}
              isOnDark={isOnDark}
            >
              <div className={cx(cardContentClassName)}>
                {label}
                {disabled && (
                  <span className={classes.notAvailable}>Not available</span>
                )}
              </div>
            </SelectableCard>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default EcommOptionsList;
